import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import PropTypes from 'prop-types';
import './circularProgressbar.scss';
import CheckIcon from '@mui/icons-material/Check';

// Defining the CircularProgressBar component
const CircularProgressBar = ({
  value,
  text,
  progressBarCss,
  progressBarIcon,
}) => {
  // Conditionally rendering the CircularProgressbar or check icon based on the value
  return value >= 100 ? (
    <div className={`circular-checkIcon ${progressBarIcon}`}>
      <CheckIcon />
    </div>
  ) : (
    <CircularProgressbar
      className={`progressBarCss ${progressBarCss}`}
      value={value}
      text={text}
    />
  );
};

// Defining propTypes for the CircularProgressBar component for type-checking
CircularProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  progressBarCss: PropTypes.string,
  progressBarIcon: PropTypes.string,
  text: PropTypes.string,
};

export default CircularProgressBar; // Exporting the component for use in other parts of the application
